export default __webpack_public_path__ + "static/arag-beratungsapp-01-um-c7c9987b6f364d710a75a4179ff1311d.jpg";